import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  Collapse,
  Grid,
  InputLabel,
  styled,
  TextField,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { ArrowForward, Close, FilterList } from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import httpclient from "../../../Utils";
import useTokenRefresh from "../../../Hooks/useTokenRefresh";

import TableComponent from "./TableComponent";
import ViewDetails from "./ViewDetails";
import { useBranch } from "../../../Hooks/useBranch";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const columns = [
  { id: "ID", name: "ID" },
  { id: "CODE", name: "Code" },
  { id: "NAME", name: "Name" },
  { id: "BRANCH", name: "Branch" },
  { id: "CCHANGED_DATE", name: "Changed Date" },
  { id: "CCHANGED_BY", name: "Changed By" },
].filter(Boolean);

const FilteredBox = styled(Box)(({ theme }) => ({
  background: "#f9f9f9",
  padding: "5px 10px",
  borderRadius: "5px",
  "& p": {
    margin: "0",
    marginRight: "10px",
    display: "inline-block",
    background: "#dedede",
    borderRadius: "10px",
    padding: "2px 5px",
  },
  "& svg": {
    fontSize: "15px",
    cursor: "pointer",
    position: "relative",
    top: "3px",
    background: theme.palette.primary.dark,
    color: "#fff",
    borderRadius: "50%",
    padding: "2px",
    marginLeft: "2px",
  },
}));

const Header = styled("div")(({ theme }) => ({
  "& h1": {
    color: theme.palette.primary.dark,
    margin: "0",
  },
}));

const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage"));

const SalesMan = (props) => {
  const {
    getTokenRefreshed: refresh,
    open: tokenOpen,
    overlay: overlay,
    setOpen: setTokenOpen,
    message: tokenMessage,
    messageState: tokenMessageState,
  } = useTokenRefresh();

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState({});

  const [rows, setRows] = useState([]);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageState, setMessageState] = useState("");

  const [loading, setLoading] = useState(false);
  const [singleLoading, setSingleLoading] = useState(false);
  const [direction, setDirection] = useState(false);
  const [currentColumn, setCurrentColumn] = useState("");
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );

  const [rowsPerPage, setRowsPerPage] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [total, setTotal] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const { currentBranch } = useBranch();

  const [filterData, setFilterData] = useState({
    ID: "",
    CODE: "",
    DESC: "",
    BRANCH: "",
    CCHANGED_DATE: "",
    FROM_DATE: null,
    TO_DATE: null,
    CCHANGED_BY: "",
    remove: false,
  });

  const [submittedData, setSubmittedData] = useState({
    ID: "",
    CODE: "",
    DESC: "",
    BRANCH: "",
    CCHANGED_DATE: "",
    FROM_DATE: null,
    TO_DATE: null,
    CCHANGED_BY: "",
    submit: false,
  });

  useEffect(() => {
    if (
      filterData.ID === "" &&
      filterData.CODE === "" &&
      filterData.DESC === "" &&
      filterData.BRANCH === "" &&
      filterData.CCHANGED_DATE === "" &&
      filterData.CREATE_DATE === "" &&
      filterData.FROM_DATE === "" &&
      filterData.CCHANGED_BY === ""
    ) {
      setSubmittedData({
        ...submittedData,
        submit: false,
      });
    }
    if (filterData.ID === " ") filterData.ID = "";
    if (filterData.CODE === " ") filterData.CODE = "";
    if (filterData.DESC === " ") filterData.DESC = "";
    if (filterData.BRANCH === " ") filterData.BRANCH = "";
    if (filterData.CCHANGED_DATE === " ") filterData.CCHANGED_DATE = "";
    if (filterData.FROM_DATE === " ") filterData.FROM_DATE = "";
    if (filterData.TO_DATE === " ") filterData.TO_DATE = "";
    if (filterData.CCHANGED_BY === " ") filterData.CCHANGED_BY = "";

    filterData.remove === true && handleFilter();
  }, [filterData]);

  useEffect(() => {
    let userStorage = JSON.parse(localStorage.getItem("salesman_filter"));
    userStorage !== null && setFilterData(userStorage);

    userStorage == null
      ? getAllAreas()
      : userStorage.ID === "" &&
        userStorage.CODE === "" &&
        userStorage.DESC === "" &&
        userStorage.BRANCH === "" &&
        userStorage.CCHANGED_DATE === "" &&
        userStorage.FROM_DATE === "" &&
        userStorage.TO_DATE === "" &&
        userStorage.CCHANGED_BY === "" &&
        userStorage.removed === false
      ? getAllAreas()
      : console.log("salesman!");
  }, [currentBranch]);

  const getAllAreas = () => {
    setLoading(true);
    httpclient
      .get(`/sss/salesman`)
      .then(({ data }) => {
        if (data.status === 200) {
          setRows(data.data);

          setTotal(data.meta.total);
          setRowsPerPage(parseInt(data.meta.per_page));
          setPage(data.meta.current_page);
          setFrom(data.meta.from);
          setTo(data.meta.to);
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(data.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const handleFilterOpen = () => {
    setFilterOpen((prev) => !prev);
  };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterData,
      [name]: value,
      remove: false,
    });
  };

  const handleDateChange = (name, newValue) => {
    // newValue is dayjs object from the DatePicker
    const formattedDate =
      newValue && newValue.isValid() ? newValue.format("YYYY-MM-DD") : null;

    setFilterData((prevData) => ({
      ...prevData,
      [name]: formattedDate,
      remove: false,
    }));
  };

  const handleView = (row) => {
    setSingleLoading(true);
    setOpenViewDialog(true);
    httpclient
      .get(`/sss/salesman/${row.ID}`)
      .then(({ data }) => {
        if (data) {
          setViewDetails(data.data);
          setSingleLoading(false);
        } else {
          setOpen(true);
          setMessage(data.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const sendDetails = (callback) => {
    if (callback.open === false) {
      setOpenViewDialog(false);
      setViewDetails({});
    }
    if (callback.refetch === true) {
      handleView(callback.id);
      setTimeout(() => {
        handleFilter();
      }, 1000);
    }
  };

  const handleFilter = () => {
    setSubmittedData({
      ...submittedData,
      ID: filterData.ID,
      CODE: filterData.CODE,
      DESC: filterData.DESC,
      BRANCH: filterData.BRANCH,
      CCHANGED_DATE: filterData.CCHANGED_DATE,
      FROM_DATE: filterData.FROM_DATE,
      TO_DATE: filterData.TO_DATE,
      CCHANGED_BY: filterData.CCHANGED_BY,
      submit: true,
    });
    filterData.remove = true;
    localStorage.setItem("salesman_filter", JSON.stringify(filterData));
    setLoading(true);
    if (
      filterData.ID ||
      filterData.CODE ||
      filterData.DESC ||
      filterData.BRANCH ||
      filterData.CCHANGED_DATE ||
      filterData.CCHANGED_BY
    ) {
      httpclient
        .get(
          `sss/salesman?filters[DESC][$contains]=${
            filterData.DESC
          }&filters[CODE][$eq]=${filterData.CODE}&filters[BRANCH][$eq]=${
            filterData.BRANCH
          }&filters[CCHANGED_DATE][$between][0]=${
            filterData.FROM_DATE || ""
          }&filters[CCHANGED_DATE][$between][1]=${
            filterData.TO_DATE || ""
          }&pagination=${rowsPerPage}&page=${page}`
        )
        .then(({ data }) => {
          if (data.status === 200) {
            setRows(data.data);

            setTotal(data.meta.total);
            setRowsPerPage(data.meta.per_page);
            setPage(data.meta.current_page);
            setFrom(data.meta.from);
            setTo(data.meta.to);
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(data.message);
            setMessageState("error");
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            refresh();
            setOpen(tokenOpen);
            setMessage(tokenMessage);
            setMessageState("error");
          } else if (err.response.status === 422) {
            const errorMessages = Object.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else if (err.response.status === 400) {
            const errorMessages = Object.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(err.response.data.message);
            setMessageState("error");
            setLoading(false);
          }
        });
    } else {
      getAllAreas();
    }
  };

  const handleRemove = (data) => {
    setFilterData({
      ...filterData,
      [data]: "",
      remove: true,
    });

    setSubmittedData({
      ...submittedData,
      [data]: "",
      remove: true,
    });
  };

  const handleSort = (column) => {
    setDirection((prevDirection) => !prevDirection);
    setCurrentColumn(column);
    setLoading(true);
    submittedData.submit
      ? httpclient
          .get(
            `sss/salesman?filters[DESC][$contains]=${
              filterData.DESC
            }&filters[CODE][$eq]=${filterData.CODE}&filters[BRANCH][$eq]=${
              filterData.BRANCH
            }&sort[0]=${column}:${
              !direction ? "asc" : "desc"
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(
            `sss/salesman?sort[0]=${column}:${
              !direction ? "asc" : "desc"
            }&pagination=${rowsPerPage}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleChangePage = (e, page) => {
    setLoading(true);
    submittedData.submit
      ? httpclient
          .get(
            `sss/salesman?filters[DESC][$contains]=${
              filterData.DESC
            }&filters[CODE][$eq]=${filterData.CODE}&filters[BRANCH][$eq]=${
              filterData.BRANCH
            }${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(`sss/salesman?pagination=${rowsPerPage}&page=${page}`)
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setLoading(true);

    localStorage.setItem("configRowPerPage", event.target.value);

    submittedData.submit
      ? httpclient
          .get(
            `sss/salesman?filters[DESC][$contains]=${
              filterData.DESC
            }&filters[CODE][$eq]=${filterData.CODE}&filters[BRANCH][$eq]=${
              filterData.BRANCH
            }${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${+event.target.value}&page=${page}`
          )
          .then(({ data }) => {
            setLoading(true);
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(`sss/salesman?pagination=${+event.target.value}&page=${page}`)
          .then(({ data }) => {
            setLoading(true);
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setPage(data.meta.current_page);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleEdit = (row) => {
    setViewDetails(row);
  };

  const handleDelete = (row) => {
    setViewDetails(row);
  };

  // Handle API call to update row status
  const updateRowStatus = (rowId) => {
    //setLoading(true);
    httpclient
      .post(`users/${rowId.id}/status`)
      .then(({ data }) => {
        if (data.status === 200) {
          //setLoading(false);
          setOpen(true);
          setMessageState("success");
          setMessage(data.message);
          setViewDetails({});
          getAllAreas();
        } else {
          //setLoading(false);
          setOpen(true);
          setMessageState("error");
          setMessage(data.error || data.message);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          //setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          //setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const currentChange = (value, row) => {
    if (value === "allow_update") {
      handleEdit(row);
    }

    if (value === "allow_delete") {
      handleDelete(row);
    }
  };

  const handleChangeArea = (value) => {
    setFilterData({
      ...filterData,
      ID: value !== null ? value.id : "",
      role_name: value !== null ? value.name : "",
      remove: false,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ID") {
      setFilterData({
        ...filterData,
        role_name: value,
        remove: false,
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setTokenOpen(false);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Header>
            <h1>Sales Man List</h1>
          </Header>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            color="primary"
            variant="contained"
            onClick={handleFilterOpen}
          >
            Filter <FilterList style={{ marginLeft: "5px" }} fontSize="small" />
          </Button>
        </Grid>

        {/* Filter */}
        <Grid item xs={12}>
          <Collapse in={filterOpen}>
            <Card>
              <Box p={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Code</InputLabel>
                    <TextField
                      variant="outlined"
                      name="CODE"
                      value={filterData.CODE}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleFilter();
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Name</InputLabel>
                    <TextField
                      variant="outlined"
                      name="DESC"
                      value={filterData.DESC}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleFilter();
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Branch</InputLabel>
                    <TextField
                      variant="outlined"
                      name="BRANCH"
                      value={filterData.BRANCH}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleFilter();
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>From date (Created)</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="YYYY-MM-DD"
                        name="FROM_DATE"
                        value={
                          filterData.FROM_DATE
                            ? dayjs(filterData.FROM_DATE)
                            : null
                        }
                        sx={{ width: "100%" }}
                        onChange={(newValue) =>
                          handleDateChange("FROM_DATE", newValue)
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleFilter();
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>To date (Created)</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="YYYY-MM-DD"
                        name="TO_DATE"
                        value={
                          filterData.TO_DATE ? dayjs(filterData.TO_DATE) : null
                        }
                        sx={{ width: "100%" }}
                        onChange={(newValue) =>
                          handleDateChange("TO_DATE", newValue)
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleFilter();
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <Box textAlign={"right"}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFilter}
                      >
                        Filter{" "}
                        <ArrowForward
                          fontSize="small"
                          style={{ marginLeft: "5px" }}
                        />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Collapse>
        </Grid>

        {submittedData.CODE ||
        submittedData.DESC ||
        submittedData.BRANCH ||
        submittedData.FROM_DATE ||
        submittedData.TO_DATE ? (
          <Grid item xs={12}>
            <FilteredBox>
              <span>Filtered: </span>
              {submittedData.CODE && (
                <p>
                  <span>Code: {submittedData.CODE}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("CODE")}
                  />
                </p>
              )}
              {submittedData.DESC && (
                <p>
                  <span>Name: {submittedData.DESC}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("DESC")}
                  />
                </p>
              )}
              {submittedData.BRANCH && (
                <p>
                  <span>Branch: {submittedData.BRANCH}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("BRANCH")}
                  />
                </p>
              )}
              {submittedData.FROM_DATE && (
                <p>
                  <span>From Date (Created): {submittedData.FROM_DATE}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("FROM_DATE")}
                  />
                </p>
              )}
              {submittedData.TO_DATE && (
                <p>
                  <span>To Date (Created): {submittedData.TO_DATE}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("TO_DATE")}
                  />
                </p>
              )}
            </FilteredBox>
          </Grid>
        ) : (
          <Box></Box>
        )}

        <Grid item xs={12}>
          <TableComponent
            name={"Sales Man List"}
            columns={columns}
            rows={rows}
            sort={true}
            handleView={handleView}
            handleSort={handleSort}
            updateRowStatus={updateRowStatus}
            props={props}
            options={props?.permissions}
            currentChange={currentChange}
            loading={loading}
            direction={direction}
            currentColumn={currentColumn}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            page={page}
            total={total && total}
            fromTable={from}
            toTable={to}
            rowsPerPage={rowsPerPage}
          />
        </Grid>
        {/* <Footer overlay={overlay || props.overlayNew} /> */}
      </Grid>

      {openViewDialog && (
        <ViewDetails
          singleLoading={singleLoading}
          viewDetails={viewDetails}
          sendDetails={sendDetails}
        />
      )}

      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open || tokenOpen}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={messageState || tokenMessageState}
          sx={{ width: "100%" }}
        >
          {message || tokenMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SalesMan;
